import type { ReactElement } from "react";
import { useMemo } from "react";

import ContentView from "app/pages/sales-intelligence/pages/home/components/common/ContentView/ContentView";
import SavedSearchesCard from "app/pages/sales-intelligence/pages/home/components/SavedSearchesCard/SavedSearchesCard";
import SavedSearchesCardHeaderActions from "app/pages/sales-intelligence/pages/home/components/SavedSearchesCard/SavedSearchesCardHeaderActions";
import SavedSearchesResultsView from "app/pages/sales-intelligence/pages/home/components/SavedSearchesCard/SavedSearchesResultsView";
import useSavedSearchesCountsQueries from "app/pages/sales-intelligence/pages/home/queries/useSavedSearchesCountsQueries";
import useSavedSearchesQuery from "app/pages/sales-intelligence/pages/home/queries/useSavedSearchesQuery";
import createSavedSearchesResultsViewModel from "app/pages/sales-intelligence/pages/home/services/results-view-model/saved-searches/factory";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { SHOULD_NOT_OPEN_SAVED_SEARCHES_STORAGE_KEY } from "app/pages/sales-intelligence/sub-modules/advanced-search/constants/saved-searches";

const SavedSearchesCardContainer = (): ReactElement => {
    const { data, isLoading } = useSavedSearchesQuery();

    useSavedSearchesCountsQueries(data?.searches ?? []);

    const { results, areResultsOverLimit, metadata } = useMemo(() => {
        return createSavedSearchesResultsViewModel({ data });
    }, [data]);

    const redirectToSearchPage = () => {
        siNavigator.goToAdvancedSearchPage(undefined, { isShowSavedSearchList: true });
    };

    const handleNewSearchClick = () => {
        sessionStorage.setItem(SHOULD_NOT_OPEN_SAVED_SEARCHES_STORAGE_KEY, "true");
        redirectToSearchPage();
    };

    const renderHeaderContent = (): ReactElement | undefined => {
        if (!results.length) {
            return;
        }

        return (
            <SavedSearchesCardHeaderActions
                metadata={metadata}
                onNewSearch={handleNewSearchClick}
            />
        );
    };

    return (
        <SavedSearchesCard
            metadata={metadata}
            headerContent={renderHeaderContent()}
        >
            <ContentView isLoading={isLoading}>
                <SavedSearchesResultsView
                    results={results}
                    areResultsOverLimit={areResultsOverLimit}
                    metadata={metadata}
                    onViewAll={redirectToSearchPage}
                    onRedirectToSearch={redirectToSearchPage}
                />
            </ContentView>
        </SavedSearchesCard>
    );
};

export default SavedSearchesCardContainer;
